import { render, staticRenderFns } from "./choiceCards.vue?vue&type=template&id=f5feccea&scoped=true"
import script from "./choiceCards.vue?vue&type=script&lang=js"
export * from "./choiceCards.vue?vue&type=script&lang=js"
import style0 from "./choiceCards.vue?vue&type=style&index=0&id=f5feccea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5feccea",
  null
  
)

export default component.exports